const UPDATES = [
  {
    time: '18:32',
    tag: '快讯',
    title: '某知名导演新片发布会现场被记者追问绯闻，场面一度尴尬',
    hot: true,
  },
  {
    time: '17:15',
    tag: '爆料',
    title: '网友投稿：某综艺节目录制现场导演组与嘉宾发生激烈争执',
    hot: true,
  },
  {
    time: '16:08',
    tag: '追踪',
    title: '此前被曝税务问题的MCN机构今日正式发布致歉声明',
    hot: false,
  },
  {
    time: '14:50',
    tag: '热点',
    title: '多个明星工作室今日集体发律师函，辟谣近期网络不实传闻',
    hot: true,
  },
  {
    time: '13:22',
    tag: '爆料',
    title: '业内透露某视频平台即将上线重磅独家综艺，阵容惊人',
    hot: false,
  },
  {
    time: '11:45',
    tag: '快讯',
    title: '知名娱乐博主被扒出多平台账号关联，疑似背后有专业团队运作',
    hot: true,
  },
  {
    time: '10:18',
    tag: '追踪',
    title: '昨日热点事件持续发酵，当事人好友发文疑似暗讽对方撒谎',
    hot: true,
  },
  {
    time: '09:05',
    tag: '速递',
    title: '今日黑料每日大赛更新：三大焦点专题已上线，速来围观',
    hot: false,
  },
  {
    time: '07:30',
    tag: '早报',
    title: '黑料每日速递：昨夜今晨五大热点事件汇总，吃瓜从早开始',
    hot: false,
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            实时快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            全天候滚动更新，不错过每一条最新动态
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 before:absolute before:left-3 md:before:left-3.5 before:top-2 before:bottom-2 before:w-0.5 before:bg-background-300 before:rounded-full">
            {UPDATES.map((item, idx) => (
              <div key={idx} className="relative pb-6 last:pb-0">
                <div className={`absolute left-[-1.3rem] md:left-[-1.45rem] top-1.5 w-3 h-3 rounded-full border-2 ${
                  item.hot
                    ? 'bg-primary-500 border-primary-300'
                    : 'bg-background-300 border-background-200'
                }`}></div>

                <div className="flex items-start gap-3 flex-wrap">
                  <span className="text-xs font-mono text-foreground-500 whitespace-nowrap">{item.time}</span>
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                    item.hot
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <p className="mt-1.5 text-sm md:text-base text-foreground-800 leading-relaxed">
                  {item.title}
                  {item.hot && (
                    <span className="inline-flex items-center gap-0.5 ml-2 text-xs text-primary-600">
                      <i className="ri-fire-line"></i> 热
                    </span>
                  )}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}